import styled from 'styled-components';
export const Container = styled.div.withConfig({
  displayName: "AssociationLineItemstyle__Container",
  componentId: "sc-2w6fv5-0"
})(["& + &{margin-top:8px;}[role='option'] > span{justify-content:flex-start;}"]);
export const DeleteIconWrapper = styled.div.withConfig({
  displayName: "AssociationLineItemstyle__DeleteIconWrapper",
  componentId: "sc-2w6fv5-1"
})(["transition:0.3s;opacity:", ";cursor:", ";"], ({
  isHover
}) => isHover ? 1 : 0, ({
  isHover
}) => isHover ? 'pointer' : 'default');